<div class="dcl-whats-included-modal-header">
    <img alt="" class="whats-included-header-image" [src]="source" />
    <h2 class="whats-included-header-title" [innerHTML]="[title]"></h2>
    <div class="whats-included-header-container">
        <p class="whats-included-header-message">
            {{ message }}
        </p>
    </div>
</div>
